import React from 'react';
import { IonIcon } from '@ionic/react';
import { golfOutline, peopleOutline } from 'ionicons/icons';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

interface WelcomeScreenProps {
  onCreateGame: () => void;
  onJoinGame: () => void;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onCreateGame, onJoinGame }) => {
  const { t } = useTranslation();

  return (
    <motion.div 
      className="flex flex-col items-center justify-center h-full p-4 text-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.5 }}
        className="mb-8"
      >
        <div className="bg-green-100 dark:bg-green-900/30 p-6 rounded-full mb-4 mx-auto">
          <IonIcon
            icon={golfOutline}
            className="text-green-600 dark:text-green-400 size-16"
            aria-hidden="true"
          />
        </div>
        <h1 className="text-2xl font-bold mb-2">{t('Golf Game Setup')}</h1>
        <p className="text-muted-foreground max-w-md mx-auto">
          {t('Create a new game or join an existing one to start tracking your golf scores')}
        </p>
      </motion.div>

      <div className="w-full max-w-md space-y-4">
        <motion.button
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
          onClick={onCreateGame}
          className="w-full py-4 px-6 bg-green-500 hover:bg-green-600 text-white rounded-xl font-medium flex items-center justify-center space-x-2 shadow-md active:scale-[0.98] transition-all"
        >
          <IonIcon icon={golfOutline} className="size-5" />
          <span>{t('Create New Game')}</span>
        </motion.button>
        
        <motion.button
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          onClick={onJoinGame}
          className="w-full py-4 px-6 bg-blue-500 hover:bg-blue-600 text-white rounded-xl font-medium flex items-center justify-center space-x-2 shadow-md active:scale-[0.98] transition-all"
        >
          <IonIcon icon={peopleOutline} className="size-5" />
          <span>{t('Join Existing Game')}</span>
        </motion.button>
      </div>
    </motion.div>
  );
};

export default WelcomeScreen;
